/* eslint-disable */
import RestTypeEntity from "@/js/common/Domain/Entity/RestType";
import RestTypeFactory from "../Factory/RestType";

let RestTypesRepositoryRussia = Backbone.Collection.extend({
	model: RestTypeEntity
});

RestTypesRepositoryRussia.repository = new RestTypesRepositoryRussia();

RestTypesRepositoryRussia.repository.init = function(restTypes) {
	var restTypesModelsArray = [];
	_.each(restTypes, function(restType) {
		var restTypesModel = new RestTypeFactory(restType);
		restTypesModelsArray.push(restTypesModel);
	});
	this.set(restTypesModelsArray);
};

export default RestTypesRepositoryRussia;